import { NightlyCharge } from '~/store/availability_rates/availability-rates.types'

const CHARGE_TYPE_RATE = 'RATE'
const CHARGE_TYPE_TAX = 'TAX'
const CHARGE_DESCRIPTION_RATE = 'BASE RATE'

const findByDate = (item: NightlyCharge, currentCharge: NightlyCharge): boolean => item.date === currentCharge.date
const findByDescription = (item: NightlyCharge, currentCharge: NightlyCharge): boolean => item.description === currentCharge.description

const chargeReducer = (findFunction: (a:NightlyCharge, b:NightlyCharge) => boolean) => (acc: NightlyCharge[], currentCharge: NightlyCharge) => {
  const existingChargeIndex = acc.findIndex((item) => findFunction(item, currentCharge))

  if (existingChargeIndex >= 0) {
    return [
      ...acc.slice(0, existingChargeIndex),
      {
        ...acc[existingChargeIndex],
        amountCents:
          acc[existingChargeIndex].amountCents
          + currentCharge.amountCents
      },
      ...acc.slice(existingChargeIndex + 1)
    ]
  }

  return acc.concat(currentCharge)
}

// Creates an array of
// nightly room charges with taxes included.
// For venues where VAT is included
// in advertised prices (e.g. UK Houses, some European Houses)
// Some 'RATE' types are actually fees, 
// so the description 'BASE RATE' is used to 
// filter nightly rates from other charges
const calculateNightlyChargesWithTax = (charges: NightlyCharge[]): NightlyCharge[] => charges
.filter((charge: NightlyCharge) => charge.description === CHARGE_DESCRIPTION_RATE || charge.chargeType === CHARGE_TYPE_TAX)
.reduce(chargeReducer(findByDate), [])

// Creates an array
// of nightly room charges 
// without any taxes or fees.
// For regions where prices are advertised
// without VAT/taxes (e.g. North America)
const calculateNightlyChargesWithoutTax = (charges: NightlyCharge[]): NightlyCharge[] => charges.filter((charge: NightlyCharge) => charge.description === CHARGE_DESCRIPTION_RATE)

// Creates an array of all taxes, 
// pooled together by their description.
const calculateAllTaxes = (charges: NightlyCharge[]): NightlyCharge[] => charges
  .filter((charge: NightlyCharge) => charge.chargeType === CHARGE_TYPE_TAX || (charge.chargeType === CHARGE_TYPE_RATE && charge.description !== CHARGE_DESCRIPTION_RATE))
  .reduce(chargeReducer(findByDescription), [])

// Creates an array of any additional fees or taxes
// apart from base VAT, pooled together by their description
const calculateAdditionalTaxes = (charges: NightlyCharge[]): NightlyCharge[] => charges
  .filter((charge: NightlyCharge) => charge.chargeType === CHARGE_TYPE_RATE && charge.description !== CHARGE_DESCRIPTION_RATE)
  .reduce(chargeReducer(findByDescription), [])

export { 
  calculateNightlyChargesWithTax, 
  calculateNightlyChargesWithoutTax,
  calculateAllTaxes,
  calculateAdditionalTaxes,
} 